"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateDuration = calculateDuration;

function calculateDuration() {
  var prevTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var nextTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return prevTime ? nextTime - prevTime : 0;
}


//////////////////
// WEBPACK FOOTER
// ./~/vanilla-swipe/lib/utils/calculateDuration.js
// module id = 391
// module chunks = 168707334958949